// Generated by CoffeeScript 2.7.0
(function() {
  // ******************************************************************************
  // Animation system
  // ******************************************************************************

  // Animation engine compatibility functions
  var Anim, WaitAnim, _easeInOut, _easeInOutHalfHeight, _reverseEase, cancelAnimFrame, easeInFast, easeInOutFast, easeInOutInFast, easeInOutInSmooth, easeInOutSmooth, easeInSmooth, easeLinear, easeOutFast, easeOutSmooth, easeRevInFast, easeRevInOutFast, easeRevInOutSmooth, easeRevLinear, easeRevOutFast, getScaledEaseFunct, reqAnimFrame;

  reqAnimFrame = null;

  cancelAnimFrame = null;

  if (typeof requestAnimationFrame !== "undefined" && requestAnimationFrame !== null) {
    reqAnimFrame = function(cb) {
      return requestAnimationFrame(cb);
    };
    cancelAnimFrame = function(id) {
      return cancelAnimationFrame(id); // Do it the old way using setTimeout
    };
  } else {
    reqAnimFrame = function(cb) {
      return setTimeout(cb, 0);
    };
    cancelAnimFrame = function(id) {
      return clearTimeout(id);
    }; // If animation frame is supported
  }

  // Export for external users that would want to use that
  module.exports.reqAnimFrame = reqAnimFrame;

  module.exports.cancelAnimFrame = cancelAnimFrame;

  // This is the base animation object that calculated "t" variable
  // which is a percentage of your animation. Animation goes from 0.0 to 1.0
  Anim = class Anim {
    constructor(totalTimeMS, stepCallback, easeFunct) {
      this._execFrame = this._execFrame.bind(this);
      this._calcT = this._calcT.bind(this);
      this.stop = this.stop.bind(this);
      this.then = this.then.bind(this);
      this.wait = this.wait.bind(this);
      this.totalTimeMS = totalTimeMS;
      this.stepCallback = stepCallback;
      this.easeFunct = easeFunct;
      if (this.easeFunct == null) {
        this.easeFunct = easeLinear;
      }
      this.animT = 0; // This is the percentage that goes from 0 to 1
      this.lastFrameTime = new Date().getTime();
      this.curT = 0; // The T of the current animation
      this.running = true;
      this.done = false;
      this.animID = reqAnimFrame(this._execFrame);
    }

    _execFrame() {
      var deltaMS, now;
      if (this.running) {
        if (!this.done) {
          // Calculate time delta
          now = new Date().getTime();
          deltaMS = now - this.lastFrameTime;
          this.lastFrameTime = now;
          // Calculate the T
          this.curT += deltaMS / this.totalTimeMS; // T is the % time done on the total time
          
          // I know that this is not perfect in time but we MUST call this last
          // step so the animation reache its exact final state.
          if (this.curT >= 1) {
            this.curT = 1; // TODO: We should adjust the delta...
            this.done = true;
          }
          this.stepCallback(this._calcT(this.curT), deltaMS);
          return this.animReqID = reqAnimFrame(this._execFrame);
        } else {
          this.running = false; // Set that state so the caller can check it
          if (this.thenCallback != null) {
            // To make it much better, the thenCallback should be a function returning an animation or anything else. If we detect that it's an animation, we start it and keep an handle on it so if the caller wants to stop the whole thing we have the power to do it.
            return this.animReqID = reqAnimFrame(this.thenCallback); // Call this for the next step!
          }
        }
      }
    }

    _calcT(t) {
      return this.easeFunct(t);
    }

    stop() {
      this.running = false;
      return cancelAnimFrame(this.animReqID); // This won't stop the subsequent animations. We must change the things to give us a handle that would allow us to do so.
    }

    then(callback) {
      this.thenCallback = callback;
      return this;
    }

    wait(timeMS) {}

  };

  module.exports.Anim = Anim;

  
    // This is the base animation object that calculated "t" variable
  // which is a percentage of your animation. Animation goes from 0.0 to 1.0
  WaitAnim = class WaitAnim {
    constructor(totalTime) {
      this._exec = this._exec.bind(this);
      this.stop = this.stop.bind(this);
      this.then = this.then.bind(this);
      this.totalTime = totalTime;
      this.running = true;
      this.done = false;
      this.timeoutHandle = setTimeout(this._exec, this.totalTime);
    }

    _exec() {
      this.done = true;
      this.running = false; // Set that state so the caller can check it
      if (this.thenCallback != null) {
        return setTimeout(this.thenCallback, 0); // Call this for the next step!
      }
    }

    stop() {
      this.running = false;
      return clearTimeout(this.timeoutHandle);
    }

    then(callback) {
      this.thenCallback = callback;
      return this;
    }

  };

  module.exports.WaitAnim = WaitAnim;

  
  // Easing functions

  // Linear
  module.exports.easeLinear = easeLinear = function(t) {
    return t;
  };

  module.exports.easeRevLinear = easeRevLinear = function(t) {
    return _reverseEase(t, easeLinear);
  };

  // Fast ease (Exponential)
  module.exports.easeInFast = easeInFast = function(t) {
    return Math.pow(2, 10 * (t - 1));
  };

  module.exports.easeOutFast = easeOutFast = function(t) {
    return -Math.pow(2, -10 * t) + 1;
  };

  module.exports.easeInOutFast = easeInOutFast = function(t) {
    return _easeInOutHalfHeight(t, easeInFast, easeOutFast);
  };

  module.exports.easeRevInFast = easeRevInFast = function(t) {
    return _reverseEase(t, easeInFast);
  };

  module.exports.easeRevOutFast = easeRevOutFast = function(t) {
    return _reverseEase(t, easeOutFast);
  };

  module.exports.easeRevInOutFast = easeRevInOutFast = function(t) {
    return _reverseEase(t, easeInOutFast);
  };

  module.exports.easeInOutInFast = easeInOutInFast = function(t) {
    return _easeInOut(t, easeInOutFast, easeRevInOutFast);
  };

  // Smooth, (Quad function)
  module.exports.easeInSmooth = easeInSmooth = function(t) {
    return t * t;
  };

  module.exports.easeOutSmooth = easeOutSmooth = function(t) {
    return -t * (t - 2);
  };

  module.exports.easeInOutSmooth = easeInOutSmooth = function(t) {
    return _easeInOutHalfHeight(t, easeInSmooth, easeOutSmooth);
  };

  module.exports.easeRevInOutSmooth = easeRevInOutSmooth = function(t) {
    return _reverseEase(t, easeInOutSmooth);
  };

  module.exports.easeInOutInSmooth = easeInOutInSmooth = function(t) {
    return _easeInOut(t, easeInOutSmooth, easeRevInOutSmooth);
  };

  // Use this to convert a % function to a real value function.
  // Pass a startValue, an endValue and then the % function of your choice.
  module.exports.getScaledEaseFunct = getScaledEaseFunct = function(startVal, endVal, easeF) {
    return function(t) {
      return ((endVal - startVal) * easeF(t)) + startVal;
    };
  };

  module.exports.this = this.easeOutSmooth = easeOutSmooth;

  module.exports.this = this.getScaledEaseFunct = getScaledEaseFunct;

  // Easing utilities
  _reverseEase = function(t, easeF) {
    return easeF(-t + 1);
  };

  
  // Couple two functions withou affecting their height
  _easeInOut = function(t, inF, outF) {
    if (t < 0.5) {
      return inF(t * 2);
    } else {
      return outF((t - 0.5) * 2);
    }
  };

  // Couples 
  _easeInOutHalfHeight = function(t, inF, outF) {
    if (t < 0.5) {
      return inF(t * 2) / 2;
    } else {
      return (outF((t - 0.5) * 2) / 2) + 0.5;
    }
  };

}).call(this);
